var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-ellipse-progress',{attrs:{"progress":_vm.progress,"color":_vm.color,"emptyColor":"#D8D8D8\t","size":65,"fontColor":"#253858","fontSize":"14px","thickness":5,"emptyThickness":"5"}})}
var staticRenderFns = []

export { render, staticRenderFns }